import React from 'react';
interface Btn {
  type?: string, 
  close: () => void,
}

function BtnClose(props: Btn) {  
  const {type} = props;

  if(type === 'filter')
    return (
      <ul className="close close-btn-filter" onClick={()=>props.close()}>
          <li className="bar bar-1"></li>
          <li className="bar bar-2"></li>
          <li className="bar bar-3"></li>
      </ul>
    )

  return (
    <div className="close" onClick={()=>props.close()}></div>
  )
}

export default BtnClose
